import script from "./UserMsg.vue?vue&type=script&lang=ts&setup=true"
export * from "./UserMsg.vue?vue&type=script&lang=ts&setup=true"

import "./UserMsg.vue?vue&type=style&index=0&id=40f6a430&lang=scss&scoped=true"

import exportComponent from "/apps/jenkins/workspace/client-prod/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-40f6a430"]])

export default __exports__